<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('人物筛选')" :btnName="$i18n.$t('查询')" :fields="fields" @search="search" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content hasName">
        <VisIndex ref="visIndex" :data="relationData" @doubleClick="doubleClick" hideCoOccurrence />
        <div class="page-common-container-right-content-no-data" v-if="!loading && relationData && relationData.data.length === 0 && relationData.link.length === 0">
          <img src="@/assets/map/no-data.png" alt="">
          <p>{{ emptyText }}</p>
        </div>
      </div>
      <div class="page-common-container-right-list hasName">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!relationData.data.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
          <div class="page-common-container-right-list-title-bottom">
            {{ $i18n.$t('本次图谱共查询到') }}{{ personTotal }}{{ $i18n.$t('个人物节点，') }}{{ linkTotal }}{{ $i18n.$t('条社会关系连边，全部数据请点击“导出数据”按钮导出。') }}
          </div>
        </div>
        <div class="page-common-container-right-list-content">
          <div class="page-common-container-right-list-content-title">{{ $i18n.$t('以下为按照社会关系数量排序前十位的人物：') }}</div>
          <div class="page-common-container-right-list-content-item" v-for="(per, index) in perList" :key="index">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ per.Name }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ per.relation_count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('人物名称') }}</div>
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('记载出处') }}</div>
              </div>
              <template v-for="(link, j) in per.link_node">
                <div class="page-common-container-right-list-content-item-table-row" :key="j" v-if="per.showMore || (!per.showMore && j < 4)">
                  <div class="page-common-container-right-list-content-item-table-row-td">{{ link.Name }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" :title="link.RecordedIn">{{ link.RecordedIn }}</div>
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="per.link_node.length > 4" @click.stop="per.showMore = !per.showMore">
              <template v-if="per.showMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <empty-dialog :title="$i18n.$t('未查询到该人物的社会关系网络')" ref="emptyDialog" />
  </div>
</template>
<script>
import { getPersonNextRelation, personRelation } from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'socialRelations',
  meta: {
    title: i18n.$t('社会关系')
  },
  data () {
    let sessionParams = sessionStorage.getItem('socialRelationsParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    const Name = localStorage.getItem('socialRelationsName')
    if (Name) {
      localStorage.removeItem('socialRelationsName')
      if (!sessionParams) {
        sessionParams = {}
      }
      sessionParams.Name = Name
    }
    return {
      emptyText: this.$i18n.$t('没有查询到相关的社会关系'),
      fields: [
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          placeholder: i18n.$t('请输入想要了解的人物'),
          key: 'Name',
          defaultValue: sessionParams ? (sessionParams.Name || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('人物分类'),
          placeholder: i18n.$t('全部'),
          key: 'Category',
          clearable: true,
          options: this.$store.state.dict.personCategory || [],
          defaultValue: sessionParams ? (sessionParams.Category || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('传记名称'),
          placeholder: i18n.$t('全部'),
          key: 'Biographie',
          clearable: true,
          options: this.$store.state.dict.biographieName || [],
          defaultValue: sessionParams ? (sessionParams.Biographie || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('宗派'),
          placeholder: i18n.$t('全部'),
          key: 'Sect',
          clearable: true,
          options: this.$store.state.dict.allSect || [],
          defaultValue: sessionParams ? (sessionParams.Sect || '') : null
        },
        // {
        //   type: 'address',
        //   label: i18n.$t('地点'),
        //   placeholder: i18n.$t('请输入地点名称'),
        //   key: 'Address'
        // },
        {
          type: 'selectGroup',
          label: i18n.$t('时间'),
          separator: i18n.$t('至'),
          start: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_start',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_start || '') : null
          },
          end: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_end',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_end || '') : null
          }
        },
        // },
        // {
        //   type: 'input',
        //   label: '人物著作',
        //   placeholder: '请输入想要了解的人物著作',
        //   key: 'Works'
        // },
        {
          type: 'select',
          label: i18n.$t('人物设置'),
          placeholder: i18n.$t('请选择'),
          key: 'is_extension',
          clearable: true,
          options: [
            { label: i18n.$t('显示所有人物'), value: '1' },
            { label: i18n.$t('仅显示传记人物'), value: '0' }
          ],
          defaultValue: '1'
        }
      ],
      loading: false,
      relationData: {
        data: [],
        link: []
      },
      perList: [],
      personTotal: 0,
      linkTotal: 0,
      downloadLoading: false,
      exportIds: []
    }
  },
  methods: {
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      personRelation({
        type: '社会关系',
        ...form,
        Ids: this.exportIds,
        output: 1
      }, {
        responseType: 'blob'
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('社会关系.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    doubleClick (node) {
      getPersonNextRelation({
        Id: node.Id,
        type: '社会关系'
      }).then(res => {
        const addNode = res.data.data.filter(e => {
          return !this.relationData.data.find(e2 => e.Id === e2.Id)
        })
        const addLink = res.data.link.filter(e => {
          return !this.relationData.link.find(e2 => e.source === e2.source && e.target === e2.target)
        })
        const addIds = addNode.filter(e => !this.exportIds.includes(e.Id)).map(e => e.Id)
        this.exportIds = [...this.exportIds, ...addIds]
        this.$refs.visIndex.addNodes(addNode, addLink)
      })
    },
    search (params) {
      sessionStorage.setItem('socialRelationsParams', JSON.stringify(params))
      this.getPersonRelation(params)
    },
    getPersonRelation (params) {
      this.loading = true
      personRelation({
        type: '社会关系',
        ...params
      }).then(res => {
        this.emptyText = this.$i18n.$t('没有查询到相关的社会关系')
        if (res.code && res.code === 400) {
          this.relationData = {
            data: [],
            link: []
          }
          this.$set(this.relationData, 'searchKey', '')
          this.personTotal = 0
          this.linkTotal = 0
          this.perList = []
          this.exportIds = []
          this.emptyText = this.$i18n.$t(res.msg)
          return false
        }
        this.relationData = res.data
        this.$set(this.relationData, 'searchKey', params.Name)
        this.personTotal = res.data.data.length
        this.linkTotal = res.data.link.length
        this.perList = (res.data.sidebar || []).map(e => {
          return {
            ...e,
            showMore: false
          }
        })
        this.exportIds = res.data.data.map(e => e.Id)
        if (!this.personTotal) {
          this.$refs.emptyDialog.open()
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
